// AllCategories.jsx
import React, { useState, useEffect, useRef } from "react";
import Layout from "../Layout/Layout";
import { BsGridFill } from "react-icons/bs";
import { laguangeElakay } from "../pageInside/dataElakay";
import CardAllcategories from "../pageInside/cardAllcategories";
import CategoryShowcaseGrid from "../pageInside/categoryShowcase";
import "../pageInside/categoryShowcase.css";
import { elakayAutoText } from "../pageInside/dataElakay";
import { getCategoryMatrixPreviews } from "../auth/apiCategory";
import { getMatrixChildren } from "../pageInside/CategoryMatrixPreview";
import { FirtIDCategory } from "../../config";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["allCategories"]?.[key] || fallback;

let levelarry = {
  level_0: { ar: [], ar1: [], ar2: [] },
  level_1: [],
  level_2: {}
};

const AllCategories = (props) => {
  const [loading, setLoading] = useState(true);
  const [loading0, setLoading0] = useState(false);
  const [level, setLevel] = useState(levelarry);
  const divSubCategories = useRef(null);
  const loadingTimerRef = useRef(null);
  // Ancre posée juste sous le Header (voir <Layout> plus bas) : une fois le
  // chargement des catégories terminé, on remonte en scroll fluide au début
  // du contenu -- même principe que CJDropshippingDashboard.jsx/contentTopRef,
  // mais local à cette page puisqu'elle vit hors du module CJ Dropshipping.
  // Ne remplace PAS le scroll existant vers `divSubCategories`
  // (ButtonViewCategories) qui, lui, cible intentionnellement la ligne de
  // sous-catégories dépliée.
  const contentTopRef = useRef(null);
  // Matrix Mode (Create Category toggle): `parents` map of the previews
  // endpoint -- one grouped request for the whole page, every parent with
  // Matrix Mode ON down to the sub-category sliders (levels=3). A parent
  // absent from it is OFF: its children keep their own image. A failed
  // request just leaves every card in its default mode.
  const [matrixParents, setMatrixParents] = useState({});

  const { infoSource } = props;
  __setElakayInfoSource(infoSource);
  const { loadCategory } = infoSource;

  const ButtonViewCategories = (ar, subAr, id) => {
    if (subAr.items?.length === 0) {
      setLoading0(false);
    } else if (level.id === id) {
      setLoading0(false);
      setLevel(levelarry);
    } else {
      const timer = setTimeout(() => {
        scrollToParagraph(divSubCategories);
      }, 400);
      setLoading0(true);
      let y = checkRowLine(ar, id);
      spliceArray(ar, subAr, y, id);
      return () => clearTimeout(timer);
    }
  };

  const scrollToParagraph = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    let cancelled = false;
    getCategoryMatrixPreviews(FirtIDCategory, { levels: 3 }).then((data) => {
      if (!cancelled) setMatrixParents(data?.parents || {});
    });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    let cancelled = false;
    loading && loadCategory().then(() => {
      if (cancelled) return;
      loadingTimerRef.current = setTimeout(() => {
        if (!cancelled) setLoading(false);
      }, 1000);
    });
    return () => {
      cancelled = true;
      if (loadingTimerRef.current) clearTimeout(loadingTimerRef.current);
    };
  }, []);

  // Remonte au début du contenu une fois le chargement terminé. Pas
  // `loading === true` : <Layout loading={loading}> remplace `children`
  // (donc le div contentTopRef) par l'écran de chargement tant que
  // `loading` est vrai (Layout.js:371) -- le ref serait encore null à ce
  // moment-là. On scrolle plutôt quand le contenu vient de (re)apparaître.
  useEffect(() => {
    if (!loading) {
      scrollToParagraph(contentTopRef);
    }
  }, [loading]);

  const spliceArray = (ar, subAr, i, id) => {
    var ar1, ar2;
    ar1 = ar.slice(0, i);
    ar2 = ar.slice(i);
    setLevel({
      "level_0": { ar, ar1, ar2 },
      "level_1": subAr.items,
      "level_2": subAr.items[0].supCategoryID,
      "id": id
    });
  };

  const checkRowLine = (ar, id) => {
    const w = document.getElementById("elakayRowl")?.clientWidth || 1200;
    const nxr = w < 768 ? 2 : w < 1200 ? 3 : 4;
    const i = (ar?.map(e => e.supCategoryID._id).indexOf(id) ?? -1) + 1;
    const l = Math.ceil(i / nxr);
    return l * nxr;
  };

  const menu = (
    <div className="ec-allcat-page">
      <div className="ec-allcat-header">
        <span className="ec-allcat-header-icon"><BsGridFill /></span>
        <h3 className="ec-allcat-title">{__elakayText("t002", "elakay")}{infoSource.laguangeElakay('title', infoSource.languageAPI).menu}</h3>
      </div>

      <div className="ec-allcat-body" id="elakayRowl">
        {loading0 ? (<>
          <CardAllcategories
            laguangeElakay={laguangeElakay}
            infoSource={infoSource}
            ButtonViewCategories={ButtonViewCategories}
            setLevel={setLevel}
            level={level}
            scrollToParagraph={scrollToParagraph}
            divSubCategories={divSubCategories}
            matrixParents={matrixParents}
            rootCategoryId={FirtIDCategory}
          />
          </>
        ) : (<>
          <CategoryShowcaseGrid
            items={infoSource.elakayCategories}
            infoSource={infoSource}
            ButtonViewCategories={ButtonViewCategories}
            activeId={level.id}
            matrixChildren={getMatrixChildren(matrixParents, FirtIDCategory)}
          />
          </>
        )}
      </div>
    </div>
  );

  return (
    <Layout
      infoSource={infoSource}
      title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).allCategories.t001}
      description={elakayAutoText("h_41682905073222", "Node React E-commerce App")}
      className="container-fluid"
      SliderPunShow={false}
      loading={loading}
      {...infoSource?.allSettings?.layout}
    >
      <div ref={contentTopRef} style={{ scrollMarginTop: 96 }} />
      <div className="allcategories-root" style={infoSource.styleNav}>
        {menu}
      </div>
    </Layout>
  );
};

export default AllCategories;
